// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject3":"Tech-module--seeLiveProject3--jMESa","sourceCodeProject3":"Tech-module--sourceCodeProject3--QkP_R"};